import { throttle } from 'lodash';

const changeTop = 200;
const $toTop = document.getElementById('toTop');

if ($toTop) {
  const toTop = () => {
    const { scrollY } = window;

    if (scrollY > changeTop) {
      $toTop.classList.add('content__totop--visible');
    } else {
      $toTop.classList.remove('content__totop--visible');
    }
  };

  if (!document.documentElement.classList.contains('kb-preview')) {
    window.addEventListener('scroll', throttle(toTop, 250));
  }
}
